import React from 'react';
import Button from '../Buttons/Button/Button';
import ThemedCheckbox from '../Response/Templates/ThemedCheckbox';
import styled from 'styled-components';
import { T, TString } from './Utils';
interface Props {
  data: any;
  handleSubmit: Function;
  primaryColor: string;
  shouldDisableActions: boolean;
  voiceResponse: boolean;
  langCode: string;
}
interface State {
  selectionArray: boolean[];
  selected: boolean;
}
const MultiSel = styled.div`
  .multi-option-select {
    border-top: 1px solid
      ${(props: any) => {
        return props.foreground + '4d';
      }};
  }
  .is-last-elem {
    border-bottom: 1px solid
      ${(props: any) => {
        return props.foreground + '4d';
      }};
  }

  & .multi-option-select {
    position: relative;
  }

  & .multi-option-select:hover:before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    background-color: ${(props: any) => {
      return props.foreground + '1a';
    }};
  }
  button {
    &:focus-visible:before {
      position: absolute;
      inset: 0;
      content: '';
      left: 0;
      top: 0;
      background-color: ${(props: any) => {
        return props.foreground + '33';
      }};
    }
  }
  & .multi-option-select:active:before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    background-color: ${(props: any) => {
      return props.foreground + '33';
    }};
  }
`;
const styleVars = getComputedStyle(document.querySelector(':root'));

class MultipleSelect extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      selected: false,
      selectionArray: []
    };
  }
  componentDidMount() {
    this.setState({
      selectionArray: this.props.data.lists.items.map(
        e => e.selectedFlag === '1'
      ),
      selected: this.props.data.lists.items
        .map(e => e.selectedFlag === '1')
        .includes(true)
    });
  }
  handleSelection(index) {
    this.setState(state => {
      let selectionArray = [...state.selectionArray];
      selectionArray[index] = !selectionArray[index];
      let selected = false;
      selectionArray.forEach(e => {
        if (e) {
          selected = true;
        }
      });
      return {
        ...state,
        selectionArray,
        selected
      };
    });
  }
  handleSubmit = () => {
    const selectedElements = this.props.data.lists.items.filter(
      (_, index) => this.state.selectionArray[index]
    );
    if (selectedElements.length === 0) return;
    const itemsToSend = selectedElements
      .map(e => e.actionText || e.title)
      .join(', ');
    this.props.handleSubmit(itemsToSend);
  };
  render() {
    let foreground = styleVars.getPropertyValue('--srvMsgColor') || '#ffffff';
    let { data, primaryColor } = this.props;
    return (
      <div
        style={this.props.shouldDisableActions ? { cursor: 'not-allowed' } : {}}
        tabIndex={
          this.props.voiceResponse || this.props.shouldDisableActions ? -1 : 0
        }
      >
        <MultiSel
          {...{ foreground: foreground }}
          className={`sf-multiple-w mul-sel ${
            this.props.shouldDisableActions ? 'action-disabled' : 'msg-bgm'
          }`}
        >
          <div
            className="body-text-1"
            dangerouslySetInnerHTML={{
              __html: data.displayResponse
            }}
            style={{ padding: '12px 16px' }}
          />
          <div className="sf-multiple-result-w sf-multiple-select-result-w ">
            {data.lists.items.length > 0 &&
              data.lists.items.map((eachOption, index) => {
                return (
                  <button
                    disabled={this.props.shouldDisableActions}
                    aria-label={`
                    ${TString({
                      labelName: 'checkboxLabel',
                      langCode: this.props.langCode,
                      fromClass: true
                    })}
                     ${eachOption.title} ${
                      this.state.selectionArray[index]
                        ? `${TString({
                            labelName: 'SelectedLabel',
                            langCode: this.props.langCode,
                            fromClass: true
                          })}`
                        : `${TString({
                            labelName: 'unselectedLabel',
                            langCode: this.props.langCode,
                            fromClass: true
                          })}`
                    }`}
                    className={`sf-listItem action-elem-multi  body-text-1 multi-option-select ${
                      index === data.lists.items.length - 1
                        ? 'is-last-elem'
                        : ''
                    } `}
                    key={index}
                    onClick={this.handleSelection.bind(this, index)}
                  >
                    <ThemedCheckbox
                      primaryColor={primaryColor}
                      selected={this.state.selectionArray[index]}
                    />
                    <span className="body-text-1">{eachOption.title}</span>
                  </button>
                );
              })}

            {data.lists.items.length > 0 ? (
              <div
                className={`submit`}
                style={this.state.selected ? { opacity: '1' } : {}}
              >
                <Button
                  className={`submit-btn ${!this.state.selected ||
                    (this.props.shouldDisableActions && 'disabled')}`}
                  fullWidth={true}
                  onClick={this.handleSubmit}
                  disabled={
                    !this.state.selected || this.props.shouldDisableActions
                  }
                >
                  <T labelName="submitLabel" />
                </Button>
              </div>
            ) : null}
          </div>
        </MultiSel>
      </div>
    );
  }
}
export default MultipleSelect;
